import React from 'react'
import { Dropdown, Menu } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import * as DROPDOWN from 'constant/dropdown'
import PropTypes from 'prop-types'
import EditArticle from 'view/page/article-management/component/edit-article'
import formatArticle from 'helper/format-input-fields'
import styles from './styles'
import DeleteArticle from './component/delete'
import PublishArticle from './component/publish'
import PinArticle from './component/pin'
import NewAttachment from './component/new-attachment'

const Action = ({ article }) =>
  (<span>
    <Dropdown
      overlay={
        <Menu>
          <Menu.Item>
            <EditArticle article={formatArticle(article)} />
          </Menu.Item>
          <Menu.Item>
            <DeleteArticle article={article} />
          </Menu.Item>
          <Menu.Item >
            <PublishArticle article={article} />
          </Menu.Item>
          <Menu.Item>
            <PinArticle article={article} />
          </Menu.Item>
          <Menu.Item>
            <NewAttachment article={article} />
          </Menu.Item>
        </Menu>
      }
      overlayStyle={{ zIndex: 1 }}
      trigger={[DROPDOWN.TRIGGER]}
    >
      <div className={styles.show_more}>
        <span>More</span>
        <DownOutlined />
      </div>
    </Dropdown>
  </span>)

Action.propTypes = {
  article: PropTypes.object
}

export default Action
